import { createFileRoute } from "@tanstack/react-router";
import { ShieldAlert } from "lucide-react";

import { PageWrapper } from "~/components/page-wrapper";
import { Alert, AlertDescription, AlertTitle } from "~/components/ui/alert";
import { Skeleton } from "~/components/ui/skeleton";
import { useEmployeePermissions } from "~/hooks/use-employee-permissions";
import { getWorkInProgressMessage } from "~/utils/work-in-progress-messages";

export const Route = createFileRoute("/_authenticated/settings/menus")({
  component: MenusPage,
});

function MenusPage() {
  const { hasPermission, isLoading, hasEmployee } = useEmployeePermissions();
  const canEditMenus = hasPermission("editMenus");

  // Loading state
  if (isLoading) {
    return (
      <PageWrapper description="Configure POS menu settings" title="POS Menus">
        <Skeleton className="h-96 w-full" />
      </PageWrapper>
    );
  }

  // No employee record linked
  if (!hasEmployee) {
    return (
      <PageWrapper description="Configure POS menu settings" title="POS Menus">
        <Alert>
          <ShieldAlert className="h-4 w-4" />
          <AlertTitle>No Employee Profile</AlertTitle>
          <AlertDescription>
            Your account is not linked to an employee profile. Contact your
            organization admin to set up your employee record with the
            appropriate permissions.
          </AlertDescription>
        </Alert>
      </PageWrapper>
    );
  }

  // No permission to edit menus
  if (!canEditMenus) {
    return (
      <PageWrapper description="Configure POS menu settings" title="POS Menus">
        <Alert variant="destructive">
          <ShieldAlert className="h-4 w-4" />
          <AlertTitle>Access Denied</AlertTitle>
          <AlertDescription>
            You don't have permission to edit menu settings. Contact your
            manager to request access.
          </AlertDescription>
        </Alert>
      </PageWrapper>
    );
  }

  const message = getWorkInProgressMessage();

  return (
    <PageWrapper description="Configure POS menu settings" title="POS Menus">
      <div className="subtitle text-muted-foreground">{message}</div>
    </PageWrapper>
  );
}
